var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('prismic-rich-text',{attrs:{"field":_vm.slice.primary.text,"htmlSerializer":_vm.htmlSerializer}})}
var staticRenderFns = []

export { render, staticRenderFns }